import type { Release } from '../releases.ts';

export default {
  version: '0.15.0',
  date: '2026-10-02',
  title: 'Phone version',
  summary: [
    'A phone version that opens by itself on phones',
    'Search, play, fix titles and work through tasks on the phone',
    'Upload from the phone’s camera or files; uploads resume after a dropped connection',
    'Add PRISM to the home screen',
  ],
  features: [
    'A phone version at /m, opened automatically on phones: search and browse the library, play media, fix titles and descriptions, and work through your tasks',
    'Upload from the phone: record video or take a photo with the camera straight from the browser (iPhone and Android, no app), or choose files; uploads resume after a dropped connection',
    'PRISM can be added to the home screen, and a phone can switch between the phone and desktop versions',
  ],
  fixes: [],
} satisfies Release;
